const NA = 'NA';
const NONE = 'NONE';
const UNIT = 'UNIT';
const DEEP = 'DEEP';
const ASSIGNEE_UNIT = 'ASSIGNEE_UNIT';
const ASSIGNEE_DEEP = 'ASSIGNEE_DEEP';

export const NO_RESTRICTION = 'NO_RESTRICTION';

export const PERMITTED_PERMISSIONS = [
  UNIT,
  DEEP,
  ASSIGNEE_UNIT,
  ASSIGNEE_DEEP,
];

export const NOT_PERMITTED_PERMISSIONS = [
  NA,
  NONE,
];
